<template>
<div>
  <md-dialog
    v-if="type === 'filter'"
    :md-active.sync="showFilter"
    v-on:md-clicked-outside="closeDialog"
    class="md-elevation-14">
    <md-dialog-title v-if="$te(`filters.label.${filter.label}`)">
      {{ $t(`filters.label.${filter.label}`) }}
    </md-dialog-title>
    <md-dialog-title v-else>
      Filter
    </md-dialog-title>
    <md-divider />
    <md-dialog-content>

      <div v-if="filter.type === 'categorical'">
        <div class="mt-2">
          <div v-for="(optName, index) in filter.options" :key="index">
            <div v-if="filter.multiple">
              <md-checkbox
                v-model="$store.state.filterValues.filters[filter.name].values"
                :value="optName"
                @change="filterValueHasChanged = true"
                class="md-primary mt-0 mb-2">
                <span v-if="$te(`filters.value.${filter.label}['${index}']`)">
                  {{ $t(`filters.value.${filter.label}['${index}']`) }}
                </span>
                <span v-else>
                  {{ `${optName.charAt(0).toUpperCase()}${optName.slice(1)}` }}
                </span>
              </md-checkbox>
            </div>
            <div v-else>
              <md-radio
                v-model="$store.state.filterValues.filters[filter.name].values"
                :value="optName"
                @change="filterValueHasChanged = true"
                class="md-primary mt-0 mb-2">
                <span v-if="$te(`filters.value.${filter.label}['${index}']`)">
                  {{ $t(`filters.value.${filter.label}['${index}']`) }}
                </span>
                <span v-else>
                  {{ `${optName.charAt(0).toUpperCase()}${optName.slice(1)}` }}
                </span>
              </md-radio>
            </div>
          </div>
        </div>
      </div>

      <div v-if="filter.type === 'hierarchical'">
        <input-tree
          :label="filter.label"
          :treeData="filter.options"
          :value.sync="$store.state.filterValues.filters[filter.name].values"
          @filterValueChanged="filterValueHasChanged = true" />
      </div>

    </md-dialog-content>
    <md-divider />
    <md-dialog-actions>
      <md-button class="md-default" @click="unsetFilter">
        {{ $t('reset') }}
      </md-button>
      <md-button class="md-primary md-raised" @click="closeDialog">
        {{ $t('ok') }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>

  <md-dialog
    v-else-if="type === 'image'"
    :md-active.sync="showImage"
    v-on:md-clicked-outside="closeDialog"
    class="md-elevation-14 image-dialog">
    <md-dialog-content>
      <img ref="image" />
    </md-dialog-content>
    <md-divider />
    <md-dialog-actions>
      <md-menu v-if="$store.state.screenSize === 'desktop'">
        <div md-menu-trigger>
          <md-button>
            {{ $t('download') }}
          </md-button>
        </div>
        <md-menu-content>

          <div>
            <md-menu-item @click="openFile(imageData.image)">
              <md-icon>photo</md-icon>
              <span class="md-list-item-text">Slide</span>
            </md-menu-item>
          </div>

          <div v-for="medium in imageData.media" :key="medium._id">
            <md-menu-item v-if="medium.pptx" @click="openFile(medium.pptx)">
              <md-icon>photo_library</md-icon>
              <span class="md-list-item-text">PowerPoint</span>
            </md-menu-item>
            <md-menu-item v-else-if="medium.pdf" @click="openFile(medium.pdf)">
              <md-icon>picture_as_pdf</md-icon>
              <span class="md-list-item-text">PDF</span>
            </md-menu-item>
            <md-menu-item v-else @click="openFile(medium)">
              <md-icon>insert_drive_file</md-icon>
              <span class="md-list-item-text">{{ $t('file') }}</span>
            </md-menu-item>
          </div>

        </md-menu-content>
      </md-menu>
      <md-button class="md-primary md-raised" :style="{ 'margin-left': ($store.state.screenSize === 'desktop') ? '8px' : '0' }" @click="closeDialog">
        {{ $t('close') }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>

  <md-dialog
    v-else-if="type === 'clients'"
    :md-active.sync="showClients"
    v-on:md-clicked-outside="closeDialog"
    class="md-elevation-14">
    <md-dialog-title>{{ $t('select_client') }}</md-dialog-title>
    <md-divider />
    <md-dialog-content>
      <div class="mt-2">
        <md-radio
          v-model="clientId"
          v-for="client in $store.state.user.clients"
          :key="client._id"
          :value="client._id">
          {{ client.label }}
        </md-radio>
      </div>
    </md-dialog-content>
    <md-divider />
    <md-dialog-actions>
      <md-button @click="closeDialog">
        {{ $t('close') }}
      </md-button>
      <md-button class="md-primary md-raised" @click="setClient">
        {{ $t('select') }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>

  <!--md-dialog
    v-else-if="type === 'upload'"
    :md-active.sync="showUpload"
    :md-click-outside-to-close=false
    :md-close-on-esc=false
    class="md-elevation-14 upload-dialog">
    <md-dialog-title>Uploader</md-dialog-title>
    <md-divider />
    <md-dialog-content>
      <md-field>
        <input
          type="file"
          id="uploader"
          name="uploader"
          ref="uploader"
          webkitdirectory mozdirectory
          accept=".png, .jpg, .jpeg, .json, .pdf, .pptx"
          v-on:change="handleUpload" />
        <label for="uploader">{{ uploaderLabel }}</label>
      </md-field>
      <div>
        <md-table v-if="fileNames.length > 0 && !uploading" v-model="fileNames" md-sort="group" md-sort-order="asc" md-fixed-header>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Name" md-sort-by="name">
              {{ item.name }}
            </md-table-cell>
            <md-table-cell md-label="Typ" md-sort-by="type">
              {{ item.type }}
            </md-table-cell>
            <md-table-cell md-label="Löschen">
              <span @click="removeFile(item.index)">
                <md-icon class="delete-icon" title="Löschen">delete</md-icon>
              </span>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div v-else-if="uploading">
          <md-progress-bar md-mode="query"></md-progress-bar>
        </div>
      </div>
    </md-dialog-content>
    <md-divider />
    <md-dialog-actions>
      <md-button class="md-default" :disabled.sync="uploadingDisabled" @click="unsetUpload">
        Zurücksetzen
      </md-button>
      <md-button class="md-primary md-raised" :disabled.sync="uploading" @click="closeDialog">
        Schließen
      </md-button>
      <md-button class="md-primary md-raised" :disabled.sync="uploadingDisabled" @click="upload">
        Hochladen
      </md-button>
    </md-dialog-actions>
  </md-dialog-->
</div>
</template>

<script>
// import _ from 'lodash'
import helpers from '@/services/helpers'
const { openFile } = helpers

export default {
  name: 'Dialog',
  props: {
    type: String,
    showFilterDialog: Boolean,
    showImageDialog: Boolean,
    showClientsDialog: Boolean,
    // showUploadDialog: Boolean,
    filter: Object,
    imageData: Object,
    onClientChange: Function
  },
  data: () => ({
    showFilter: false,
    showImage: false,
    showClients: false,
    filterValueHasChanged: false,
    clientId: ''
    /*
    showUpload: false,
    uploading: false,
    uploadingDisabled: true,
    uploaderLabel: 'Dateien auswählen',
    files: [],
    fileNames: []
    */
  }),
  mounted () {
    this.clientId = this.$store.state.user.client._id
  },
  watch: {
    showFilterDialog: function (bool) {
      this.showFilter = bool
    },
    showImageDialog: function (bool) {
      this.showImage = bool
    },
    showClientsDialog: function (bool) {
      this.showClients = bool
    },
    imageData: function (data) {
      // Request image
      this.$store.dispatch('getFile', data.image)
        .then(image => {
          this.$refs.image.src = image // Set received image blob
        })
        .catch(err => console.error(err))
    }
    /*
    showUploadDialog: function (newVal) {
      this.showUpload = newVal
    }
    */
  },
  methods: {
    openFile,
    closeDialog () {
      const $vm = this
      switch ($vm.type) {
        case 'filter':
          $vm.$emit('update:showFilterDialog', false)
          if ($vm.filterValueHasChanged) {
            $vm.$emit('getResults')
            $vm.filterValueHasChanged = false
          }
          break
        case 'image':
          $vm.$emit('update:showImageDialog', false)
          break
        case 'clients':
          $vm.$emit('update:showClientsDialog', false)
          $vm.clientId = $vm.$store.state.user.client._id
          break
        /*
        case 'upload':
          this.$emit('update:showUploadDialog', false)
          break
        */
      }
    },
    unsetFilter () {
      this.$store.dispatch('unsetFilterVariable', this.filter)
      this.$emit('update:showFilterDialog', false)
      this.$emit('getResults')
    },
    setClient () {
      this.$emit('update:showClientsDialog', false)
      this.onClientChange(this.clientId)
    }
    /*
    unsetUpload () {
      // Remove all files from input and files array
      this.files = []
      this.fileNames = []
      this.$refs.uploader.value = ''
      this.uploadingDisabled = true
      if (!this.uploading) this.uploaderLabel = 'Dateien auswählen'
    },
    handleUpload () {
      const uploadedFiles = this.$refs.uploader.files
      // Adds the uploaded file to the files and fileNames array
      _.each(uploadedFiles, (file, index) => {
        this.files.push(file)
        this.fileNames.push({
          index: index,
          name: file.name,
          type: file.name.split('.').pop()
        })
      })
      this.uploaderLabel = `${this.fileNames.length} Dateien ausgewählt`
      this.uploadingDisabled = false
    },
    removeFile (index) {
      // Remove specific file from files and fileNames array
      _.each(this.fileNames, (file, i) => {
        if (file.index === index) {
          this.fileNames.splice(i, 1)
          this.files.splice(i, 1)
          return false
        }
      })
      this.uploaderLabel = `${this.fileNames.length} Dateien ausgewählt`
    },
    upload () {
      let error = false
      const allowedFileTypes = [
        'application/json', // JSON
        'image/png', // PNG
        'image/jpeg', // JPEG, JPG
        'application/pdf', // PDF
        'application/vnd.ms-powerpoint', // PPT
        'application/vnd.openxmlformats-officedocument.presentationml.presentation' // PPTX
      ]
      _.each(this.files, ({ type }) => { // Check if files types are allowed
        if (!allowedFileTypes.includes(type) || !type) {
          error = true
          return false
        } else {
          error = false
        }
      })
      if (!error) {
        this.uploading = true
        this.uploadingDisabled = true
        this.uploaderLabel = `${this.fileNames.length} Dateien werden hochgeladen`

        const formData = new FormData()
        _.each(this.files, (file, index) => {
          formData.append('files[' + index + ']', file)
        })

        this.$store.dispatch('postFiles', formData)
          .then(() => {
            this.unsetUpload()
            this.uploaderLabel = 'Alle Dateien wurden erfolgreich hochgeladen'
            this.uploading = false
          })
          .catch(() => {
            this.uploaderLabel = 'Beim Hochladen ist ein Fehler aufgetreten'
            this.uploading = false
          })
      } else {
        this.uploaderLabel = 'Sie haben einen unerlaubten Dateitypen ausgewählt'
      }
    }
    */
  }
}
</script>

<style lang="scss">
  @import "../styles/theme";

  // Make dialog scrollable and bigger
  .md-dialog {
    min-width: 400px !important;
    @media screen and (max-width: $xsmall) {
      min-width: auto !important;
    }
    @media screen and (min-width: $xsmall + 1) and (max-width: $small) {
      width: 80%;
    }
  }
  .md-dialog-content {
    padding: 24px;
    overflow-y: auto;
  }

  .image-dialog {
    @media screen and (max-width: $xsmall) {
      .md-dialog-content {
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  /*
  .upload-dialog {
    min-width: 700px !important;
    min-height: 550px !important;
    max-height: 550px !important;
    .md-table-fixed-header {
      padding-right: 0 !important;
    }
    .md-table-fixed-header table {
      width: 100% !important;
    }
    .md-table-content {
      height: 230px !important;
      max-height: 230px !important;
    }
  }
  #uploader {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  #uploader + label {
    width: 100%;
    cursor: pointer;
    pointer-events: initial
  }
  .delete-icon {
    cursor: pointer;
    &:hover {
      color: $primary !important;
    }
  }
  */
</style>
